export const createNavigationStore = (set, get) => ({
	previousRoute: null,
	currentRoute: null,

	updateRoutes: (newRoute) => {
		const { currentRoute } = get()

		set(
			{
				previousRoute: currentRoute,
				currentRoute: newRoute
			},
			false,
			{ type: 'navigation/updateRoutes', newRoute }
		)
	}
})
